"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductSizeEditViewModel = instanceOfProductSizeEditViewModel;
exports.ProductSizeEditViewModelFromJSON = ProductSizeEditViewModelFromJSON;
exports.ProductSizeEditViewModelFromJSONTyped = ProductSizeEditViewModelFromJSONTyped;
exports.ProductSizeEditViewModelToJSON = ProductSizeEditViewModelToJSON;
exports.ProductSizeEditViewModelToJSONTyped = ProductSizeEditViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductSizeEditViewModel interface.
 */
function instanceOfProductSizeEditViewModel(value) {
    return true;
}
function ProductSizeEditViewModelFromJSON(json) {
    return ProductSizeEditViewModelFromJSONTyped(json, false);
}
function ProductSizeEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pssSizeSpecificationNo': json['pssSizeSpecificationNo'] == null ? undefined : json['pssSizeSpecificationNo'],
        'pssOrgId': json['pssOrgId'] == null ? undefined : json['pssOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'pssSpecificationName': json['pssSpecificationName'] == null ? undefined : json['pssSpecificationName'],
        'pssChestWidth': json['pssChestWidth'] == null ? undefined : json['pssChestWidth'],
        'pssClothesLength': json['pssClothesLength'] == null ? undefined : json['pssClothesLength'],
        'pssSizeWidth': json['pssSizeWidth'] == null ? undefined : json['pssSizeWidth'],
        'pssSizeLength': json['pssSizeLength'] == null ? undefined : json['pssSizeLength'],
        'pssSizeUnit': json['pssSizeUnit'] == null ? undefined : json['pssSizeUnit'],
        'sizeUnit': json['sizeUnit'] == null ? undefined : json['sizeUnit'],
        'pssRemark': json['pssRemark'] == null ? undefined : json['pssRemark'],
        'pssUseStatus': json['pssUseStatus'] == null ? undefined : json['pssUseStatus'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
        'pssDisabledDate': json['pssDisabledDate'] == null ? undefined : (new Date(json['pssDisabledDate'])),
        'pssOrder': json['pssOrder'] == null ? undefined : json['pssOrder'],
    };
}
function ProductSizeEditViewModelToJSON(json) {
    return ProductSizeEditViewModelToJSONTyped(json, false);
}
function ProductSizeEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pssSizeSpecificationNo': value['pssSizeSpecificationNo'],
        'pssOrgId': value['pssOrgId'],
        'oName': value['oName'],
        'pssSpecificationName': value['pssSpecificationName'],
        'pssChestWidth': value['pssChestWidth'],
        'pssClothesLength': value['pssClothesLength'],
        'pssSizeWidth': value['pssSizeWidth'],
        'pssSizeLength': value['pssSizeLength'],
        'pssSizeUnit': value['pssSizeUnit'],
        'sizeUnit': value['sizeUnit'],
        'pssRemark': value['pssRemark'],
        'pssUseStatus': value['pssUseStatus'],
        'useStatus': value['useStatus'],
        'pssDisabledDate': value['pssDisabledDate'] == null ? undefined : (value['pssDisabledDate'].toISOString()),
        'pssOrder': value['pssOrder'],
    };
}
